export const ALMACEN_SELECCIONADO_STORAGE_KEY = 'citrusPlanner.codAlmacenSeleccionado'
export const ALMACEN_SELECCIONADO_EVENT = 'citrusPlanner:almacenSeleccionado'

export const getAlmacenSeleccionado = () => {
  if (typeof window === 'undefined') return ''

  return window.localStorage.getItem(ALMACEN_SELECCIONADO_STORAGE_KEY) || ''
}

export const setAlmacenSeleccionado = (codAlmacen) => {
  if (typeof window === 'undefined') return

  const value = codAlmacen ? String(codAlmacen) : ''

  if (value) {
    window.localStorage.setItem(ALMACEN_SELECCIONADO_STORAGE_KEY, value)
  } else {
    window.localStorage.removeItem(ALMACEN_SELECCIONADO_STORAGE_KEY)
  }

  window.dispatchEvent(new CustomEvent(ALMACEN_SELECCIONADO_EVENT, { detail: value }))
}
